const Theme = {
  // Coolors palette:
  // Primary/Secondary https://color.romanuke.com/tsvetovaya-palitra-1545/
  // Grey: https://coolors.co/f8f9fa-e9ecef-dee2e6-ced4da-adb5bd-6c757d-495057-343a40-212529
  color: {
    // Main colors
    mainBlack: "#100606",
    primary: "#547b01",
    primary_dark: "#304C02",
    primary_light: "#90A900",
    secondary: "#B9C21D",

    grey_9: "#212529",
    grey_8: "#343A40",
    grey_7: "#495057",
    grey_6: "#6C757D",
    grey_5: "#ADB5BD",
    grey_4: "#CED4DA",
    grey_3: "#DEE2E6",
    grey_2: "#E9ECEF",
    grey_1: "#F8F9FA",

    mainGrey: "#CED4DA",
    mainWhite: "#FFFFFF",

    // Not used yet
  },

  shadow: {
    light: "box-shadow: 0px 0px 15px 0px rgba(163,163,163,1);",
    dark: "box-shadow: 0px 0px 15px 0px rgba(120,120,120,1);",
    darkest: "box-shadow: 0px 0px 15px 0px rgba(46,46,46,1);",
  },

  radius: "0.25rem",
  spacing: "0.1rem",

  sizes: {
    maxWidth: "1170px",
    xs: "320px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },
};

export default Theme;
